import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Router, ActivationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, tap, filter } from 'rxjs/operators';
import { RouterGo, RouteChange, ERouterActions } from '../actions/router.action';
import { Location } from '@angular/common';

@Injectable()
export class RouterEffects {
    constructor(
        private actions$: Actions,
        private router: Router,
        private location: Location,
        private store: Store<any>,
    ) {
        this.listenToRouter();
    }

    @Effect({ dispatch: false })
    navigate$ = this.actions$.pipe(
        ofType('[Router] Go'),
        map((action: RouterGo) => action.payload),
        tap(({ path, queryParams, extras }) => this.router.navigate(path, { queryParams, ...extras })),
    );

    @Effect({ dispatch: false })
    navigateBack$ = this.actions$.pipe(
        ofType(ERouterActions.ROUTER_BACK),
        tap(() => this.location.back()),
    );

    private listenToRouter() {
        this.router.events.pipe(filter(event => event instanceof ActivationEnd)).subscribe((event: ActivationEnd) =>
            this.store.dispatch(
                new RouteChange({
                    params: { ...event.snapshot.params },
                    path: event.snapshot.routeConfig.path,
                }),
            ),
        );
    }
}
